<template>
    <div id="loan-management-list" class="m-4">
        <div class="vx-row mb-4">
            <div class="vx-col w-full lg:w-full">
                <vx-card class="mt-2" card-background="dark">
                    <h1 class="bold big-title m-0 text-white">
                        Gestión de <span class="success">Créditos</span>.</h1>
                </vx-card>
            </div>
        </div>
        <!-- kpis -->
        <div v-if="isMounted" class="vx-row same-h mb-base">
            <div class="vx-col sm:w-full md:w-3/4">
                <vx-card class="p-1">
                    <div class="flex justify-between mb-2">
                        <h4 class="bold mb-4">Resumen general de créditos</h4>
                        <vs-button class="small" color="primary" icon-pack="feather"
                                    icon="icon-rotate-cw" @click.stop="fetchData()">Actualizar</vs-button>
                    </div>
                    <vs-list>
                        <vs-list-item :title="`Aprobaciones no ofertadas (${approvedLoansWithProposal.total})`">
                            <div class="flex align-items-md-center">
                                {{ costFormat(approvedLoansWithProposal.total_amount) }}
                                <vs-button class="small p-1 ml-4 " type="border" color="success" icon-pack="feather"
                                    icon="icon-eye" @click.stop="handleTableData(approvedLoansWithProposal)">Ver
                                    Proyectos</vs-button>
                            </div>
                        </vs-list-item>
                        <vs-list-item
                            :title="`Ofertas realizadas pendientes de aceptar (${loanOfferedNotAccepted.total})`">
                            <div class="flex align-items-md-center">
                                {{ costFormat(loanOfferedNotAccepted.total_amount) }}
                                <vs-button class="small p-1 ml-4 " type="border" color="success" icon-pack="feather"
                                    icon="icon-eye" @click.stop="handleTableData(loanOfferedNotAccepted)">Ver
                                    Proyectos</vs-button>
                            </div>
                        </vs-list-item>
                        <vs-list-item
                            :title="`Créditos aceptados pendientes de publicar (${loanAcceptedNotPublished.total})`">
                            <div class="flex align-items-md-center">
                                {{ costFormat(loanAcceptedNotPublished.total_amount) }}
                                <vs-button class="small p-1 ml-4 " type="border" color="success" icon-pack="feather"
                                    icon="icon-eye" @click.stop="handleTableData(loanAcceptedNotPublished)">Ver
                                    Proyectos</vs-button>
                            </div>
                        </vs-list-item>
                        <vs-list-item :title="`Monto publicado pendiente de ser fondeado (${fundingLoans.total})`">
                            <div class="flex align-items-md-center">
                                {{ costFormat(fundingLoans.total_amount) }}
                                <vs-button class="small p-1 ml-4 " type="border" color="success" icon-pack="feather"
                                    icon="icon-eye" @click.stop="handleTableData(fundingLoans)">Ver
                                    Proyectos</vs-button>
                            </div>
                        </vs-list-item>
                        <vs-list-item :title="`Créditos fondeados no dispersados (${fundedLoans.total})`">
                            <div class="flex align-items-md-center">
                                {{ costFormat(fundedLoans.total_amount) }}
                                <vs-button class="small p-1 ml-4 " type="border" color="success" icon-pack="feather"
                                    icon="icon-eye" @click.stop="handleTableData(fundedLoans)">Ver
                                    Proyectos</vs-button>
                            </div>
                        </vs-list-item>
                    </vs-list>
                </vx-card>
            </div>
            <div class="vx-col sm:w-full md:w-1/4">
                <vx-card>
                    <div class="vx-row">
                        <div class="vx-col sm:w-full">
                            <p class="bold text-md">Monto total a financiar</p>
                            <h1 class="bold"><span class="success mr-2">$</span>
                                {{ format_price(
                                    approvedLoansWithProposal.total_amount
                                    + loanOfferedNotAccepted.total_amount
                                    + loanAcceptedNotPublished.total_amount
                                    + fundingLoans.total_amount
                                ) }}
                            </h1>
                            <small>Suma de los créditos aprobados y en fondeo.</small>
                        </div>
                        <vs-divider></vs-divider>
                        <div class="vx-col sm:w-full">
                            <p class="bold text-md">Balance disponible de RedGirasol</p>
                            <h1 class="bold"><span class="success mr-2">$</span>{{ format_price(finalBalance) }}</h1>
                            <small>Dato calculado en tiempo real</small>
                        </div>
                    </div>
                </vx-card>
            </div>
        </div>
        <!-- data table -->
        <div v-if="isMounted" class="vx-row">
            <div class="vx-col w-full">
                <vx-card>
                    <vs-table v-if="isMounted" :max-items="25" pagination stripe search noDataText="No hay registros disponibles"
                        :data="loansData">
                        <template slot="header">
                            <h3>Lista de créditos
                                <br>
                                <p class="text-base">{{ description }}</p>
                            </h3>
                        </template>
                        <template slot="thead">
                            <vs-th class="bold" v-for="(col, idx) in columns" v-bind:key="idx"
                                :sort-key="col.sortable ? col.key : null">{{ col.title }}</vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr @mouseenter="mouseEvent(1)" @mouseleave="mouseEvent(2)" class="table-item" :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td :data="tr.id">
                                    <a class="clickable-img bold" @click="handleSelected(tr.id)">{{ tr.id }} | {{ tr.alias|| "--" }}</a>
                                </vs-td>
                                <vs-td :data="tr.id">
                                    <b>{{ tr.fiscal_name }}</b> <br>
                                    <vs-chip :color="isMoral(tr.person_type) ? 'danger' : '#1f74ff'">{{
                                        translatePersonalType(tr.person_type) }}</vs-chip>
                                </vs-td>
                                <vs-td :data="tr.id">
                                    <b v-if="tr.origination_responsible_id">
                                        {{ tr.origination_responsible_id }} | {{ tr.origination_responsible }}
                                    </b>
                                    <b v-else> -- </b>
                                </vs-td>
                                <vs-td :data="tr.id">
                                    <b v-if="tr.credit_risk_responsible_id">
                                        {{ tr.credit_risk_responsible_id }} | {{ tr.credit_risk_responsible }}

                                    </b>
                                    <b v-else> -- </b>
                                </vs-td>
                                <vs-td :data="tr.id">
                                    <b>{{ tr.financial_product_name }}</b> <br>
                                    {{ costFormat(tr.financed_amount) }}
                                </vs-td>
                                <vs-td :data="tr.id">
                                    {{ regularDateFormat(tr.approved_date) || "--" }} <br>
                                    <small>Días transcurridos: {{ TT(tr.approved_date) }}</small>
                                </vs-td>
                                <vs-td :data="tr.id">
                                    {{ regularDateFormat(tr.loan_proposal_timestamp) || "--" }} <br>
                                    <small>Días transcurridos: {{ TT(tr.loan_proposal_timestamp) }}</small>
                                </vs-td>
                                <vs-td :data="tr.id">
                                    {{ regularDateFormat(tr.credit_acceptance_date) || "--" }} <br>
                                    <small>Días transcurridos: {{ TT(tr.credit_acceptance_date) }}</small>
                                </vs-td>
                                <vs-td :data="tr.id" class="">
                                    <div class="date-display relative">
                                        {{ regularDateFormat(tr.public_date) || "--" }} <br>
                                        <small>Días transcurridos: {{ TT(tr.public_date) }}</small>
                                    </div>
                                    <div v-if="hasRole('credit_risk') || hasRole('treasury') | hasRole('admin')" class="flex relative menu-display">
                                        <vs-button v-if="tr.approved_date != null && tr.loan_proposal_timestamp == null" class="small p-1 ml-2"
                                            color="primary" type="border"
                                            icon-pack="feather" icon="icon-send"
                                            @click.stop="requestPostLoanOffer(tr)">OFERTAR</vs-button>
                                        <vs-button v-if="tr.credit_acceptance_date != null && tr.public_date == null"
                                            class="small p-1 ml-2" color="dark" icon-pack="feather"
                                            icon="icon-eye" type="border"
                                            @click.stop="publish(tr)">PUBLICAR</vs-button>
                                        <vs-button v-if="tr.credit_acceptance_date != null && tr.public_date == null"
                                            @click.stop="publish(tr, true), needsToBeFunded = true"
                                            class="small p-1 ml-2" color="success" icon-pack="feather" type="border"
                                            icon="icon-globe">PUBLICAR Y FONDEAR</vs-button>
                                        <vs-button v-if="tr.public_date != null && tr.fund_date == null"
                                        @click.stop="requestFundProject(tr)"
                                            class="small p-1 ml-2" color="warning" icon-pack="feather" type="border"
                                            icon="icon-dollar-sign">FONDEAR</vs-button>
                                    </div>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import formatHelper from '@mixins/formatHelper';
import dateHelper from '@mixins/dateHelper';
import projectStatusesHelper from '@mixins/projectStatusesHelper';
import { mapActions } from 'vuex';
import {ValidationBehavior} from '../../../views/admin/projects/process-flow/ValidationBehavior';
import projectValidationHelper from "@/helpers/projectValidationHelper";
import userIdentityHelper from "@/helpers/userIdentityHelper";
import swal from "sweetalert";
import LoanResponsibleChip from '../RiskModel/LoanRequest/components/LoanResponsibleChip.vue';

const columns = [
    { title: "PID", key: "pid", sortable: true }
    , { title: "SOLICITANTE", key: "applicant", sortable: true }
    , { title: "EJECUTIVO DE ORIGINACIÓN", key: "origination_responsible", sortable: true }
    , { title: "EJECUTIVO DE RIESGO", key: "credit_risk_responsible", sortable: true }
    , { title: "FINANCIAMIENTO", key: "finance", sortable: true }
    , { title: "F. APPROBACIÓN", key: "approved_date", sortable: true }
    , { title: "F. OFERTA", key: "loan_proposal_date", sortable: true }
    , { title: "F. ACEPTACIÓN DE CRÉDITO", key: "credit_acceptance_date", sortable: true }
    , { title: "F. PUBLICACIÓN", key: "loan_publish_date", sortable: true }
    // , { title: "ACCIONES", key: "tools", sortable: false }
];
export default {
    name: "LoanManagementList",
    mixins: [
        formatHelper, 
        dateHelper,
        userIdentityHelper,
        projectValidationHelper,
        projectStatusesHelper
    ],
    components: {
        LoanResponsibleChip
    },
    data: () => ({
        columns: columns,
        isMounted: false,
        finalBalance: 0,
        approvedLoansWithProposal: [],
        loanAcceptedNotPublished: [],
        loanOfferedNotAccepted: [],
        fundingLoans: [],
        loansData: [],
        fundedLoans: [],
        description: "Todos los créditos aprobados y en proceso de fondeo.",
        loan: null,
        needsToBeFunded: false
    }),
    props: {
        source: String
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        ...mapActions('projects', [
            'publishProject',
        ]),
        async fetchData() {
            this.showLoading(true);
            const data = await axios.get("/api/v2/projects/getLoanManagementList");
            this.finalBalance = data.data.final_balance;
            this.approvedLoansWithProposal = data.data.approved_loans_with_offer;
            this.loanAcceptedNotPublished = data.data.loan_acepted_not_published;
            this.loanOfferedNotAccepted = data.data.loan_offered_not_accepted;
            this.fundingLoans = data.data.funding_loans;
            this.fundedLoans = data.data.funded_loans;
            this.isMounted = true;
            this.loansData = data.data.all_loans;
            this.needsToBeFunded = false;
            this.showLoading(false);
        },
        handleTableData(data) {
            this.isMounted = false;
            this.loansData = data.loans;
            this.description = data.description;
            this.isMounted = true;
        },
        async handleSelected(id) {
            window.open(`/risk-model/expediente/${id}`, '_blank');
        },
        isMoral(personType) {
            return personType == 0 || personType == 3;
        },
        // OFERTAR CRÉDITO
        requestPostLoanOffer(loan) {
            this.loan = loan;
            this.$vs.dialog({
                color: "warning",
                type: "confirm",
                title: "Enviar oferta de crédito",
                text: "Se enviará una nueva oferta de crédito al solicitante para que la acepte. ¿Desea continuar?",
                acceptText: "Enviar oferta de crédito",
                cancelText: 'Cerrar',
                accept: this.postLoanOffer
            });
        },
        async postLoanOffer() {
            this.showLoading(true);
            try {
                await axios.post(`/api/loan-onboarding/post/${this.loan.id}/send-loan-offer`);
                await this.fetchData();
                this.showLoading(false);
                swal("Oferta de crédito enviada", "La oferta de crédito ha sido enviada al cliente", "success");
            } catch (err) {
                this.showLoading(false);
                const res = err.response;
                const data = res.data;
                swal("Error", data.error, "error");
            }
        },
        // PUBLICAR CRÉDITO
        async publish(loan, needsToBeFunded = false) {
            try {
                this.showLoading(true);
                this.loan = loan;
                const extraValidation = await this.runExtraValidations(loan);

                if (!extraValidation.isValid) {
                    this.showLoading(false);
                    swal("Ups!", extraValidation.errorText);
                    return;
                }

                let validator = ValidationBehavior.publicProjectFromTresury(loan)
                if (validator.valid) {
                    this.showLoading(false);
                    this.needsToBeFunded = needsToBeFunded;
                    this.requestPublishProject();
                } else {
                    this.showLoading(false);
                    swal("Ups!", validator.errors, "error")
                }
                this.showLoading(false);
            } catch (error) {
                this.showLoading(false);
                console.log(error);
                // const res = error.response;
                // const data = res.data;
                // swal("Error", data.error, "error");
            }
        },
        requestPublishProject() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: `Publicar crédito ${this.loan.alias} - ${this.loan.id}`,
                text: `¿Estás seguro que deseas publicar el crédito en nuestro portal? El crédito estará disponible para fondeo.`,
                acceptText: "Publicar crédito",
                cancelText: 'Cancelar',
                accept: this.doPublishProject
            });
        },
        async doPublishProject() {
            try {
                this.showLoading(true);
                await this.publishProject({
                    id: this.loan.id,
                    first_payment_date: null
                });
                if(this.needsToBeFunded) {
                    this.doFundProject();
                }
                await this.fetchData();
                let successMessage = `¡El proyecto ${this.loan.alias} - ${this.loan.id} se publicó correctamente! \n
                                    El proyecto se publicó con los siguientes parametros: \n
                                    - Monto mínimo de inversión: ${this.mxnFormat(this.loan.finance.minimal_investment)} \n
                                    - Inversión por RedGirasol: ${this.mxnFormat(this.loan.finance.financed_amount * 0.01)}`;
                this.showLoading(false);
                swal("Ok!", successMessage, "success");
            } catch (e) {
                this.showLoading(false);
                console.error(e)
                swal("Ups!", AxiosErrorException(e), "error")
            }
        },
        async runExtraValidations(project) {
            console.log("Validando proyecto", project);
            let errors = [];

            // Validar Art47 CUITF
            const art47Status = await this.validateLoanLimitsCUITF47(project.id, project.client_id);
            if (!art47Status.is_valid) {
                if (art47Status.error != null) {
                    errors.push("El solicitante no cumple con los límites de CUITF 47. No se ha encontrado información de límites. \n" + art47Status.error);
                } else {
                    errors.push(`
                        El solicitante no cumple con los límites de CUITF 47. \n
                        - Límite ${this.mxnFormat(art47Status.max_limit)}. \n
                        - Monto solicitado ${this.mxnFormat(art47Status.current_financed_amount)}. \n
                        - Monto ya publicado ${this.mxnFormat(art47Status.auxFinancedAmount)}. \n
                        - PIDS publicados: ${art47Status.project_ids}. \n
                    `);
                }
            }

            // Validar identificación de identidad
            const identityStatus = await this.getUserIdentityStatus(project.user_id);
            if (identityStatus != 1) {
                errors.push(this.handleIdentityStatus(identityStatus, true));
            }

            const finalBalance = await this.validateRgFinalBalance(project.id);
            if (!finalBalance.can_invest) {
                const moneyNeeded = (finalBalance.minimum_to_invest - finalBalance.rg_available_money);
                errors.push(`RedGirasol no tiene saldo suficiente para para invertir en este proyecto. Saldo actual: ${this.mxnFormat(finalBalance.rg_available_money)}, faltante: ${this.mxnFormat(moneyNeeded)} .`);
            }

            const isProjectValid = await this.validateLoanGuarantee(project.id);
            if (!isProjectValid) {
                errors.push("El proyecto no cuenta con garantía de crédito.");
            }

            let errorStr = "";
            if (errors.length > 0) {
                errors.forEach(err => {
                    errorStr += err + "\n";
                });
            }

            return {
                isValid: errors.length == 0,
                errors: errors,
                errorText: errorStr
            }

        },
        // fondear proyectos
        async requestFundProject(loan) {
            this.loan = loan;
            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: `Fondear crédito ${this.loan.alias} - ${this.loan.id}`,
                text: `¿Estás seguro que deseas fondear el crédito?`,
                acceptText: "Fondear crédito",
                cancelText: 'Cancelar',
                accept: this.doFundProject
            });
        },
        async doFundProject()
        {
            try {
                this.showLoading(true);
                await axios.post(`/api/project/${this.loan.id}/fundProject`);
                await this.fetchData();
                this.showLoading(false);
                swal("Fondeo exitoso", "El proyecto ha sido fondeado correctamente", "success");
            } catch (err) {
                this.showLoading(false);
                const res = err.response;
                const data = res.data;
                swal("Error", data.error, "error");
            }
        }
    },
}
</script>
<style>
.menu-display {
    visibility: hidden; 
    opacity: 0; 
    left: -1rem;
    top: -1rem;
}
.date-display {
    visibility: visible;
    opacity: 1;
    top: 0rem;
}

.table-item:hover {
    cursor: pointer;
}
    .table-item:hover .menu-display {
        visibility: visible;
        opacity: 1;
        transition: visibility 0s, opacity .1s linear;
    }
    .table-item:hover .date-display {
        visibility: hidden;
        opacity: 0;

    }

</style>